function defaultNow() {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }
  return Date.now();
}

export function createSingleFlightPrefetchCache({ now = defaultNow } = {}) {
  let activePromise = null;
  let activeStartedAt = null;

  function reset() {
    activePromise = null;
    activeStartedAt = null;
  }

  function prime(loader) {
    if (!activePromise) {
      activeStartedAt = now();
      activePromise = Promise.resolve()
        .then(() => loader())
        .catch((error) => {
          reset();
          throw error;
        });
    }
    return activePromise;
  }

  async function consume(loader) {
    const consumeStartedAt = now();
    const prefetched = Boolean(activePromise);
    const prefetchStartedAt = prefetched ? activeStartedAt : null;
    const promise = prefetched ? activePromise : prime(loader);
    try {
      return {
        value: await promise,
        prefetched,
        prefetchLeadMs:
          prefetchStartedAt === null ? null : Math.max(0, Math.round(consumeStartedAt - prefetchStartedAt)),
        waitedMs: Math.max(0, Math.round(now() - consumeStartedAt)),
      };
    } finally {
      if (promise === activePromise) {
        reset();
      }
    }
  }

  return {
    consume,
    prime,
    reset,
  };
}
